import styled from "styled-components";

export const CandidateInfo = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: #1e2228;
  padding: 10px;
`;

export const MainContainer = styled.div`
  padding: 10px 20px;
  border: 1px solid #efeff0;
  box-sizing: border-box;
  box-shadow: 0px 4px 44px rgba(29, 37, 45, 0.03);
  border-radius: 12px;
  background: #ffffff;
  margin: 10px 0;
  cursor: pointer;
  background: white;
  width: 100%;
  box-shadow: 0px 4px 44px rgba(29, 37, 45, 0.03);
`;

export const CandidateDetailsContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: baseline;
`;

export const CardDetails = styled.div`
display: flex;
justify-content: space-between;
align-items: baseline;
`;

export const JobDetailsContainer = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
`;

export const RecruiterDetailsContainer = styled.span`
font-style: normal;
font-weight: 400;
font-size: 14px;
margin-top: 15px;
/* identical to box height */
display: flex;
align-items: center;
text-align: right;
color: #1e2228;
margin-top: 0px;
`;

export const ShortlistedCandidates = styled.p`
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 17px;
/* identical to box height */
display: flex;
align-items: center;
text-align: right;
color: #1e2228;
margin-top: 0px;
`;

export const CandidateInfoContainer = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
padding-top: 20px;
@media (max-width: 768px) {
  display: grid;
  grid-template-columns: 50% 50%;
}
`;

export const Dot = styled.div`
height:5px;
width:5px;
border-radius:50%;
background:#C8CACC;
`

export const Role = styled.span`

  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #1e2228;
`;
export const ContestTagDiv = styled.div`
  padding: 6px;
  border-radius: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #ffffff;
  background: #FF2C91;
  border: 1px solid #FF2C91;
  border-radius: 4px;
  margin-left: 12px;
`;
